const STORAGE_KEY = 'crawl-form-state';

// Non-sensitive form state only — safe to persist in localStorage to improve UX.
// Sensitive fields (passwords, session cookies, tokens) are intentionally
// excluded to mitigate XSS exfiltration risk: they stay only in React state
// and are re-entered if the user reloads.
const PERSISTED_FIELDS = [
  'url', 'urlList', 'isBatch', 'isRecursive', 'maxPages', 'urlPrefix', 'forceRecrawl',
  'authMode', 'username', 'googleEmail',
  'rememberGoogleSession', 'useSavedGoogleSession',
];

export function loadPersistedCrawlState() {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    return raw ? JSON.parse(raw) : {};
  } catch (err) {
    if (process.env.NODE_ENV === 'development') {
      console.info('[crawlPersistence] load skipped:', err.message);
    }
    return {};
  }
}

export function persistCrawlState(state) {
  try {
    const toSave = {};
    for (const key of PERSISTED_FIELDS) {
      if (state[key] !== undefined && state[key] !== '') {
        toSave[key] = state[key];
      }
    }
    localStorage.setItem(STORAGE_KEY, JSON.stringify(toSave));
  } catch (err) {
    // localStorage unavailable (private browsing, quota exceeded, etc.) —
    // persistence is a UX enhancement, not critical. Log in dev only.
    if (process.env.NODE_ENV === 'development') {
      console.info('[crawlPersistence] persist skipped:', err.message);
    }
  }
}
